import Vue from 'vue';

Vue.component('lang-select', {
    /**
     * Vue.js instance reactive data variables.
     *
     * @return {Object}
     */
    data() {
        return {
            currentLang: 'nl',
        };
    },

    /**
     * Called when the Vue.js instance is mounted and
     * ready for use.
     *
     * @return {void}
     */
    mounted() {
        this.currentLang = localStorage.getItem('eye_able_translate') ?? 'nl';
    },

});
